module.exports = __webpack_public_path__ + "static/img/1489_phase_function_Paper_PointsHejduk_Prediction.fad8300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1489_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YlXk
// module chunks = 0